import { PlatformTheme } from "./useTheme";
import { StyleObject } from "styletron-standard";
import { useStyletron as useBaseStyletron } from "baseui";

// Wrapper to provide the theme and css from baseui with custom types
export const useStyletron = (): [
  css: (a: StyleObject) => string,
  theme: PlatformTheme
] => {
  const [css, theme] = useBaseStyletron();

  return [css, theme as PlatformTheme];
};
